import React from "react"
import { Button } from "./button"

interface Props {
    onClick?: () => void,
    children?: React.ReactNode,
    className?: string,
}

const MenuButton: React.FC<Props> = ({
    onClick,
    children,
    className = "",
}) => {
    return (
        <Button
            onClick={onClick}
            className={`w-[40px] h-[40px] ${className}`}
            variant={"outline"}
        >
            {children}
        </Button>
    )
}

export default MenuButton
